import React from "react";
import { useTranslation } from "react-i18next";
import {MessageOutlined} from "@ant-design/icons"
import {PhoneCall} from "lucide-react"

const CtaBand = () => {
  const {t,i18n} = useTranslation()
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-blue-700 to-blue-900 py-8 md:py-16 text-center text-white">
      
      {/* Background glow */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[20%] top-1/2 h-[300px] w-[300px] -translate-y-1/2 rounded-full bg-white/10 blur-3xl"></div>
        <div className="absolute right-[20%] top-1/2 h-[300px] w-[300px] -translate-y-1/2 rounded-full bg-yellow-400/20 blur-3xl"></div>
      </div>

      <div className="container relative mx-auto px-4">
        
        <h2 className="mb-4 text-[clamp(28px,3.6vw,40px)] font-extrabold tracking-tight">
         {t("Ready to run your store smarter?")}
        </h2>

        <p className="mx-auto mb-7 max-w-[600px] text-lg text-blue-100">
         {t( "Join 1,000+ Egyptian retailers selling faster with Hisabak. Setup is free and takes 10 minutes.")}
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          
          <a
            href="https://wa.me/201004505666?text=I%20want%20to%20start%20Hisabak"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-xl bg-white px-7 py-4 text-[16px] font-semibold text-blue-700 transition hover:bg-yellow-100 hover:-translate-y-1 hover:shadow-lg"
          >
            <MessageOutlined style={{marginRight:"5px"}}/> {t("Start Free on WhatsApp")}
          </a>

          <a
            href="tel:+201004505666"
            className="inline-flex items-center rounded-xl border border-white/40 px-7 py-4 text-[16px] font-semibold text-white transition hover:bg-white/10"
          >
           <PhoneCall style={{marginRight:"5px"}}/> {t("Call +20 100 450 5666")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;